import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AplicacionesService } from '../aplicaciones/aplicaciones.service';
import { ModuloService } from '../modulo/modulo.service';
import { HttpParams } from '@angular/common/http';
import { AccionesService } from '../acciones/acciones.service';
import { AccesosPerfilService } from './accesos-perfil.service';
import { TablesService } from '../generico/tables/tables.service';
import { OrdenMenuService } from '../orden-menu/orden-menu.service';
import { MatDialog } from '@angular/material/dialog';
import { OrdenMenuComponent } from '../orden-menu/orden-menu.component';
import { MensajeService } from '../generico/servicio/mensaje.service';

@Component({
  selector: 'app-acciones-menu-perfil',
  templateUrl: './acciones-menu-perfil.component.html',
  styleUrls: ['./acciones-menu-perfil.component.scss']
})
export class AccionesMenuPerfilComponent implements OnInit {

  accesosForm : FormGroup;
  modulos : any = [];
  tipo_opcion = [
    {'descripcion' : 'Menu', 'valor' : 1},
    {'descripcion' : 'Acciones', 'valor' : 2}
  ];

  ver_tabla = false;

  recurso ='';
  columnas = [];
  nombre_tabla = 'table-accesos-perfil';
  target
  params = {};

  menu_add = [];
  menu_remove = [];

  accion_add = [];
  accion_remove = [];



  constructor(private fb : FormBuilder,
              private app_serv : AplicacionesService,
              private mod_serv : ModuloService,
              private acceso_serv : AccesosPerfilService,
              private tb_serv : TablesService, 
              private orden_serv : OrdenMenuService,
              private dialog: MatDialog,
              private msg_serv : MensajeService
              ) { 
  }

  ngOnInit(): void {

    this.accesosForm = this.fb.group({
      modulo: [null,[Validators.required]],
      tipo: [null,[Validators.required]],
    });

    this.target = document.querySelector('#btn_accesos_perfil');
    this.consultar_modulos();
  }

  public consultar_modulos(){

    this.mod_serv.aplicacion = this.app_serv.aplica;

    this.mod_serv
        .consultar_modulos()
        .then(
          ()=>{
            this.modulos = this.mod_serv.modulos;
          }
        );

  }

  consultar_menus_acciones(){
    let tipo = this.accesosForm.get('tipo').value; 
    let fk_modulo = this.accesosForm.get('modulo').value;
    let app = this.app_serv.aplica.id_aplicacion;
    this.ver_tabla = false;

    if (tipo == 1) {
      this.recurso = 'gestionarPerfilMenu/'+this.acceso_serv.id_perfil;
      this.params = {app}
      this.columnas = ['descripcion', 'ruta', 'estado', 'acciones'];
      this.ver_tabla = true;
    }else if(tipo == 2){
      this.recurso = "adicionaAccionPerfil/"+this.acceso_serv.id_perfil;
      this.params = {app};
      this.columnas = ['descripcion', 'ruta', 'acciones'];
      this.ver_tabla = true
    }

    if (fk_modulo){
      this.params['fk_modulo'] = fk_modulo;
    }

    if (this.tb_serv.tablas[this.nombre_tabla]){
      this.tb_serv.tablas[this.nombre_tabla].cargar_datos(this.params, this.recurso, this.columnas);
    }

  }

  @HostListener('add_menu_perfil')
  add_menu_perfil(){

    this.orden_serv.num_orden = null;
    const dialogRef = this.dialog.open(OrdenMenuComponent, {
      width: '400px',
    });

    this.orden_serv.dialogRef = dialogRef;

    dialogRef.afterClosed()
             .subscribe(
               ()=>{
                
                let id_opcion_menu = this.tb_serv.params_event.id_opcion_menu;
                let ind_orden = this.orden_serv.num_orden;
                let ind_mathc = false;

                if (ind_orden){
                  for (let i = 0; this.menu_add.length; i++){
                    if (this.menu_add[i].id_opcion_menu == id_opcion_menu){
                      ind_mathc = true;
                      this.menu_add[i].ind_orden = ind_orden ;
                      break;            
                    }
                  }
  
                  if (!ind_mathc){
                    this.menu_add.push({id_opcion_menu, ind_orden});
                  }

                  this.msg_serv.ver_mensaje('Menú  adicionado.', '', this.msg_serv.TIPO_INFO);
                  this.tb_serv.tablas[this.nombre_tabla].actualizar_fila_actual('estado', 'Adicionado');
                }
                
               }
              );
  }

  onSubmit(){

    let ind_datos_post = this.menu_add.length||this.menu_remove.length||this.accion_add.length||this.accion_remove.length;    let ind_gestion = false;

    if (!ind_datos_post){
      this.msg_serv.ver_mensaje('Debe seleccionar al menos un menú o acción para remover o adicionar.',
                                '',
                                this.msg_serv.TIPO_ERROR);
      return;
    }

    ind_gestion = ind_gestion || this.add_menu_gestion();
    ind_gestion = ind_gestion || this.remove_menu_gestion();

    ind_gestion = ind_gestion || this.add_accion_gestion();
    ind_gestion = ind_gestion || this.remove_accion_gestion();

    if (!ind_gestion){
      this.acceso_serv.dialoRef.close();
    }

    
  }

  add_menu_gestion(){

    let ind_gestion = false;

    if (this.menu_add.length){
      let dataform = {
        'app' : this.app_serv.aplica.id_aplicacion,
        'id_p_perfil' : this.acceso_serv.id_perfil,
        "ind_adicion" : 1,
        "menu" : this.menu_add
      };
      this.acceso_serv.gestionar_acceso(dataform)
          .then(
            ()=>{
              this.menu_add = [];
              if (this.tb_serv.tablas[this.nombre_tabla]){
                this.tb_serv.tablas[this.nombre_tabla].cargar_datos(this.params);
              }
            }
            );

      ind_gestion = true;
    }

    return ind_gestion;

  }

  /**
   * se encarga de rellenar el arrray de los menus a remover
   */
  @HostListener('remover_menu_perfil')
  remover_menu_perfil(){
     
    let id_opcion_menu = this.tb_serv.params_event.id_opcion_menu;
    let ind_orden = 1;
    let ind_mathc = false;

    for (let i = 0; this.menu_remove.length; i++){
      if (this.menu_remove[i].id_opcion_menu == id_opcion_menu){
        ind_mathc = true;
        break;            
      }
    }

    if (!ind_mathc){
      this.menu_remove.push({id_opcion_menu, ind_orden});
    }

    this.msg_serv.ver_mensaje('Menú  removido.', '', this.msg_serv.TIPO_INFO);
    this.tb_serv.tablas[this.nombre_tabla].actualizar_fila_actual('estado', 'Removido')

  }

  remove_menu_gestion(){

    let ind_gestion = false;

    if (this.menu_remove.length){
      let dataform = {
        'app' : this.app_serv.aplica.id_aplicacion,
        'id_p_perfil' : this.acceso_serv.id_perfil,
        "ind_adicion" : 0,
        "menu" : this.menu_remove
      };
      this.acceso_serv.gestionar_acceso(dataform)
          .then(
            ()=>{
              this.menu_remove = [];
              this.recargar_tabla();
            }
            );

      ind_gestion = true;
    }

    return ind_gestion;

  }


  @HostListener('add_accion_perfil')
  add_accion_perfil(){
    let id_accion = this.tb_serv.params_event.id_accion;

    if (this.accion_add.indexOf(id_accion) < 0){
      this.accion_add.push(id_accion);
    }

    this.msg_serv.ver_mensaje('Accion adicionada.', '', this.msg_serv.TIPO_INFO);
    this.tb_serv.tablas[this.nombre_tabla].actualizar_fila_actual('estado', 'Adicionada');
  }

  add_accion_gestion(){

    let ind_gestion = false;

    if (this.accion_add.length){
      let dataform = {
        'app' : this.app_serv.aplica.id_aplicacion,
        "ind_add" : 1,
        "perfiles" : [{
          "id_p_perfil": this.acceso_serv.id_perfil,
          "acciones" : this.accion_add
        }]
      };
      
      this.acceso_serv.gestionar_acceso_accion(dataform)
          .then(
            ()=>{
              this.accion_add = [];
              this.recargar_tabla();
            }
            );

      ind_gestion = true;
    }

    return ind_gestion;

  }


  @HostListener('remover_accion_perfil')
  remove_accion_perfil(){
    let id_accion = this.tb_serv.params_event.id_accion;

    if (this.accion_remove.indexOf(id_accion) < 0){
      this.accion_remove.push(id_accion);
    }

    this.msg_serv.ver_mensaje('Accion removida.', '', this.msg_serv.TIPO_INFO);
    this.tb_serv.tablas[this.nombre_tabla].actualizar_fila_actual('estado', 'Removida');
  }

  remove_accion_gestion(){

    let ind_gestion = false;

    if (this.accion_remove.length){
      let dataform = {
        'app' : this.app_serv.aplica.id_aplicacion,
        "ind_add" : 0,
        "perfiles" : [{
          "id_p_perfil": this.acceso_serv.id_perfil,
          "acciones" : this.accion_remove
        }]
      };
      
      this.acceso_serv.gestionar_acceso_accion(dataform)
          .then(
            ()=>{
              this.accion_remove = [];
              this.recargar_tabla();
              
            }
            );

      ind_gestion = true;
    }

    return ind_gestion;

  }

  /**
   * Recarga la data de las tablas 
   */
  recargar_tabla(){
    if(this.tb_serv.tablas[this.nombre_tabla]){
      this.tb_serv.tablas[this.nombre_tabla].cargar_datos(this.params);
    }
  }

}
